import { type ActionItem } from 'shared/ui'
import { type UrlShortener } from 'entities/ShortLink/model/UrlShortener'
import { deleteCustomDomain } from 'pages/settings/pages/urlShortener/ui/actions/actionItems/deleteCustomDomain'
import { type UrlShortenerStore } from 'pages/settings/pages/urlShortener'
import { editCustomDomain } from 'pages/settings/pages/urlShortener/ui/actions/actionItems/editCustomDomain'

export const getUrlShortenerActions = (
  urlShortener: UrlShortener,
  store: UrlShortenerStore
): ActionItem[] => {
  const { getCustomDomain, isStatusPendingPayment, isStatusActive } = store

  const editAction = editCustomDomain(store.urlShortenerModalStore, urlShortener)
  const deleteAction = deleteCustomDomain(
    store.urlShortenerModalStore,
    urlShortener,
    getCustomDomain
  )
  const actions = [deleteAction]

  if (!isStatusPendingPayment && !isStatusActive) actions.unshift(editAction)

  return actions
}
